// this.$store.state.profesiograma, this.$store.state.categoriaCargo, this.$store.state.examenCargo y this.$store.state.cargoProfesiograma
import { serverTimestamp } from "firebase/firestore";

// PROFESIOGRAMAS
export const profesiograma = class {
  constructor() {
    return {
      id: "",
      idEmpresa: "",
      nombre: "",
      registro: {
        idUsuario: "",
        idEmpresa: "",
        estado: "Creado",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};

export const categoriaCargo = class {
  constructor() {
    return {
      id: "",
      idEmpresa: "",
      nombre: "",
      registro: {
        idUsuario: "",
        idEmpresa: "",
        estado: "Creado",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};

export const examenCargo = class {
  constructor() {
    return {
      id: "",
      idEmpresa: "",
      nombre: "",
      registro: {
        idUsuario: "",
        idEmpresa: "",
        estado: "Creado",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};

export const cargoProfesiograma = class {
  constructor() {
    return {
      id: "",
      idCategoria: "",
      idEmpresa: "",
      nombre: "",
      profesiogramas: [],
      registro: {
        idUsuario: "",
        idEmpresa: "",
        estado: "Creado",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};
